import BaseAPIClient from './base/BaseAPIClient';

export default class AdminClient extends BaseAPIClient {
  getProfile(schoolId) {
    return this._get(
      `v2/campus-administration/profile/`,
      { schoolId }
    );
  }
  setProfile(schoolId, request){
    return this._post(
      `v2/campus-administration/profile/`,
      { schoolId, ...request }
    );
  }
  getFeedbackReport(schoolId, pageToken){
    return this._get('v2/campus-administration/reports/feedback/', {
      schoolId,
      pageToken,
    });
  }
  getFeedbackMetrics(schoolId){
    return this._get('v2/campus-administration/reports/feedback-metrics/', {
      schoolId,
    });
  }
  inviteStudent(schoolId, email, firstName, lastName, message, individualAllowance, workshopAllowance) {
    return this._post(
      `v2/campus-administration/student/invite/`, { 
        schoolId, 
        email, 
        firstName, 
        lastName, 
        message, 
        individualAllowance, 
        workshopAllowance 
      }
    );
  }
  getDistinctUserTags(schoolId){
    return this._get('v2/campus-administration/reports/distinct-user-tags/', { schoolId });
  }
  addSessionCredits(schoolId, credits){ 
    return this._post('v2/campus-administration/credits/session/add', { 
      schoolId, 
      credits 
    });
  }
  removeSessionCredits(schoolId, credits){ 
    return this._post('v2/campus-administration/credits/session/remove', { 
      schoolId, 
      credits 
    });
  }
  addWorkshopCredits(schoolId, credits){ 
    return this._post('v2/campus-administration/credits/workshop/add', { 
      schoolId, 
      credits 
    });
  }
  removeWorkshopCredits(schoolId, credits){ 
    return this._post('v2/campus-administration/credits/workshop/remove', { 
      schoolId, 
      credits 
    });
  }
}
